module.exports = __webpack_public_path__ + "img/xian_terracotta_army.a4ed7b69.jpg";